import RegularText from '@/components/RegularText';
import { Checkbox, TextField } from '@shopify/polaris';

interface IProps {
  checkboxLabel?: string;
  inputLabel?: string;
  inputValue?: string;
  inputPlaceholder?: string;
  checked?: boolean;
  onInputChange?: (value: string) => void;
  onCheckboxChange?: (value: boolean) => void;
  limit?: number;
  disabled?: boolean;
}
const CheckboxInput = ({
  checked,
  checkboxLabel,
  inputLabel,
  inputPlaceholder,
  inputValue,
  onCheckboxChange,
  onInputChange,
  limit,
  disabled = false,
}: IProps) => {
  return (
    <div className="d-flex flex-column gap-4">
      <Checkbox
        label={<RegularText>{checkboxLabel}</RegularText>}
        checked={checked}
        onChange={onCheckboxChange}
        disabled={disabled}
      />
      {checked && (
        <TextField
          value={inputValue}
          onChange={onInputChange}
          autoComplete="off"
          label={inputLabel}
          labelHidden={!inputLabel}
          placeholder={inputPlaceholder}
          maxLength={limit}
          showCharacterCount={limit !== undefined}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default CheckboxInput;
